<template>
  <div>
    <v-btn color="primary" depressed class="mb-4" @click="toggleForm">+ добавить сотрудника</v-btn>
    <v-form class="pt-4" v-model="valid" ref="newStafferForm" v-if="showNewStafferForm">
      <v-row>
        <v-col cols="12" md="6" class="py-1 mb-8">
          <MaskedTextField
            :pattern="/[А-Яа-яёЁ]/"
            v-model="firstname"
            :rules="[rules.required('Введите имя')]"
            label="Имя"
          />
        </v-col>
        <v-col cols="12" md="6" class="py-1 mb-8">
          <MaskedTextField
            :pattern="/[А-Яа-яёЁ-]/"
            v-model="surname"
            :rules="[rules.required('Введите фамилию')]"
            label="Фамилия"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="py-1">
          <v-text-field
            :rules="[rules.required('Введите e-mail'), rules.email]"
            v-model="email"
            outlined
            label="E-mail"
            dense
          />
        </v-col>
        <v-col cols="12" md="6" class="py-1">
          <v-text-field
            :rules="[rules.required('Введите номер телефона'), rules.phone]"
            v-model="phone"
            v-mask="'+7(9##) ###-##-##'"
            outlined
            label="Мобильный телефон"
            dense
          />
        </v-col>
      </v-row>
      <v-row class="mb-4">
        <v-col cols="12" md="6" class="py-0" v-for="{ label, value } in availableAccess" :key="value">
          <v-checkbox class="mt-0" color="#88BD1F" dense :label="label" v-model="access" :value="value"></v-checkbox>
        </v-col>
      </v-row>
      <div class="mb-4 d-flex justify-end flex-wrap mx-n1">
        <div class="pa-1">
          <v-btn @click="addStaffer" :disabled="!valid" color="primary" text depressed>сохранить и добавить еще</v-btn>
        </div>
        <div class="pa-1">
          <v-btn @click="addStafferAndClose" :disabled="!valid" color="primary" depressed>добавить сотрудника</v-btn>
        </div>
      </div>
    </v-form>
    <v-data-table
      :mobile-breakpoint="100"
      class="bidlist-table"
      :headers="headers"
      :items="employes"
      item-key="id"
      :footer-props="footerProps"
      :no-data-text="noDataText"
      :options.sync="tableOptions"
      :server-items-length="total"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small @click="deleteDialogOpen(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <v-card>
        <v-card-title class="headline">Удаление сотрудника</v-card-title>
        <v-card-text v-if="employeeToDelete">
          {{ employeeToDelete.fullname }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialogClose">Отмена</v-btn>
          <v-btn color="error" text @click="deleteEmployeeConfirm">удалить</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { getEmployeeAccess } from "@/api/user";
import { formatPhone } from "@/utils/helpers";
import { email as ruleEmail } from "@/utils/rules";

import { mask } from "vue-the-mask";
import MaskedTextField from "@/components/common/MaskedTextField";

export default {
  name: "OptionStaff",
  directives: { mask },
  components: {
    MaskedTextField,
  },

  async mounted() {
    this.getEmployes();
  },
  data() {
    return {
      availableAccess: [],
      access: [],
      firstname: "",
      surname: "",
      email: "",
      phone: "",
      valid: false,
      showNewStafferForm: false,
      employeeToDelete: null,
      deleteDialog: false,
      headers: [
        { text: "Фамилия", value: "surname", sortable: false },
        { text: "Имя", value: "firstname", sortable: false },
        { text: "Телефон", value: "login", sortable: false },
        { text: "E-mail", value: "email", sortable: false },
        { value: "actions", sortable: false },
      ],
      noDataText: "Нет данных о сотрудниках",
      footerProps: {
        itemsPerPageText: "Сотрудников на странице:",
        itemsPerPageAllText: "Все",
        pageText: "{0}-{1} из {2}",
        itemsPerPageOptions: [10, 15, 20, 30, 50],
      },
      rules: {
        required: (msg) => (v) => !!v || msg,
        minOne: (v) => v.length > 0 || "Выберите хотя бы один пункт",
        email: ruleEmail,
        phone: (v) => !!v && v.replace(/\D/g, "").length === 11,
      },
    };
  },
  computed: {
    ...mapState("common", ["showOptions"]),
    ...mapGetters("employes", ["employes", "page", "pageSize", "total"]),
    isActive() {
      return this.$parent.isActive;
    },
    formattedPhone() {
      return this.phone.replace(/\D/g, "");
    },
    tableOptions: {
      get() {
        return {
          page: this.page,
          itemsPerPage: this.pageSize,
        };
      },
      set({ page, itemsPerPage }) {
        this.setPage(page);
        this.setPageSize(itemsPerPage);
      },
    },
  },
  watch: {
    // закрываем при переходе в другую вкладку меню
    isActive(current, old) {
      if (old && !current && this.showNewStafferForm) {
        this.close();
      }
    },
    // закрываем при закрытии окна настроек
    showOptions(current) {
      if (!current && this.showNewStafferForm) {
        this.close();
      }
    },

    tableOptions: {
      handler() {
        this.getEmployes();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("employes", ["getEmployes", "addEmployee", "deleteEmployee"]),
    ...mapMutations("employes", ["setPage", "setPageSize"]),
    async addStaffer() {
      const res = await this.addEmployee({
        surname: this.surname,
        firstname: this.firstname,
        phone: this.formattedPhone,
        email: this.email,
        access: this.access,
      });

      if (res) {
        this.$refs.newStafferForm.reset();
      }
      return res;
    },

    async addStafferAndClose() {
      const res = await this.addStaffer();
      if (res) {
        this.showNewStafferForm = false;
      }
    },

    close() {
      this.$refs.newStafferForm.reset();
      this.showNewStafferForm = false;
    },

    async open() {
      const res = await this.getEmployeeAccess();
      if (res.ok) {
        this.showNewStafferForm = true;
      }
    },

    async getEmployeeAccess() {
      const res = await getEmployeeAccess();
      if (res && res.list && res.list.length) {
        this.availableAccess = res.list
          .filter(({ obj }) => !!obj)
          .map(({ obj }) => {
            const item = { value: obj };
            switch (obj) {
              case "agent.app.add":
                item.label = "Создание и просмотр собственных заявок";
                // ставим это значение выбранным по умолчанию
                this.access.push(obj);
                break;
              case "agent.subpartner.list":
                item.label = 'Просмотр раздела "Команда"';
                break;
              case "billing.payments.list":
                item.label = 'Просмотр раздела "Оплата"';
                break;
              case "view_parent_apps":
                item.label = "Просмотр всех заявок";
                break;
              default:
                item.label = obj;
                break;
            }
            return item;
          });
      }
      return { ok: Boolean(res) };
    },

    toggleForm() {
      if (this.showNewStafferForm) {
        this.close();
      } else {
        this.open();
      }
    },
    deleteDialogOpen(employee) {
      this.employeeToDelete = employee;
      this.deleteDialog = true;
    },
    deleteDialogClose() {
      this.employeeToDelete = null;
      this.deleteDialog = false;
    },
    async deleteEmployeeConfirm() {
      const res = await this.deleteEmployee(this.employeeToDelete.id);
      if (res) {
        this.deleteDialogClose();
      }
    },
  },
};
</script>
